module.exports = __webpack_public_path__ + "static/media/36-7.b6bdcd79.mp3";